import React from 'react';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import HookForm from 'hook-form-controls/HookForm';
import CancelButton from 'core/buttons/CancelButton';
import SubmitButton from 'core/buttons/SubmitButton';
import FormTextField from 'hook-form-controls/FormTextField';

const validationSchema = Yup.object().shape({
  remarks: Yup.string().required('Remarks is required'),
});

export default function UpdateRejectedToCompletedForm({ onSubmit, onCancel }) {
  const { isLoading } = useSelector((state) => state.transactions.updateRejectedToCompleted);

  const methods = useForm({
    defaultValues: {
      remarks: '',
    },
    resolver: yupResolver(validationSchema),
  });

  return (
    <HookForm {...methods} onSubmit={onSubmit}>
      <Grid container gap={3}>
        <Grid item xs={12}>
          <Alert severity="warning">
            Make sure you have a valid reason for updating the rejected transaction status. This action cannot be
            undone.
          </Alert>
        </Grid>
        <Grid item xs={12}>
          <FormTextField name="remarks" label="Remarks" multiline />
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
            <SubmitButton isLoading={isLoading}>SUBMIT</SubmitButton>
            <CancelButton type="button" onClick={onCancel} disabled={isLoading}>
              Cancel
            </CancelButton>
          </Box>
        </Grid>
      </Grid>
    </HookForm>
  );
}

UpdateRejectedToCompletedForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

